import ProductLimitReportTableActionsOverlay from '../modals/overlays/ProductLimitReportTableActionsOverlay'

const ProductLimitReportTableRow = ({row, actionComponent}: any) => {
  return (
    <tr>
      <td>
        <div className='d-flex align-items-center py-2'>
          <div className='symbol symbol-40px me-3 border'>
            <img src={row.thumbnail_url} alt={row.productName} />
          </div>
          <div className='d-flex flex-column'>
            <span>{row.productName}</span>
          </div>
        </div>
      </td>
      <td>{row.sku}</td>
      <td>{row.inventory}</td>
      <td>{row.minOrderQuantity}</td>
      <td>{row.maxOrderQuantity}</td>
      <td>{row.availabilityDescription}</td>
      {actionComponent && (
        <td>
          <ProductLimitReportTableActionsOverlay id={row?.productId} name={row?.productName} />
        </td>
      )}
    </tr>
  )
}

export default ProductLimitReportTableRow
